"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ToastContainer_1 = require("./ToastContainer");
exports.default = ToastContainer_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ToastContainer/index.js
// module id = 1280
// module chunks = 8